<template>
  <div class="pagination-container" v-if="totalPages > 1">
    <ul>
      <li v-if="pages.current > 1">
        <router-link tag="button" :to="{ query: query(1) }">&laquo;</router-link>
      </li>
      <li v-if="pages.current > 1">
        <router-link tag="button" :to="{ query: query(pages.current - 1) }">&lsaquo;</router-link>
      </li>
      <li v-for="page in pages.pagesArray" :key="page">
        <router-link tag="button" :to="{ query: query(page) }">
          {{
          page
          }}
        </router-link>
      </li>
      <li v-if="pages.current < totalPages">
        <router-link tag="button" :to="{ query: query(pages.current + 1) }">&rsaquo;</router-link>
      </li>
      <li v-else-if="!pages.current">
        <router-link tag="button" :to="{ query: {_page : 2} }">&rsaquo;</router-link>
      </li>
      <li v-if="pages.current < totalPages || !pages.current">
        <router-link tag="button" :to="{ query: query(totalPages) }">&raquo;</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "DirectoryPagination",
  props: {
    totalOfEntries: {
      type: Number,
      default: 1
    },
    entriesPerPage: {
      type: Number,
      default: 1
    }
  },
  methods: {
    query(pagina) {
      return {
        ...this.$route.query,
        _page: pagina
      };
    }
  },
  computed: {
    pages() {
      const current = Number(this.$route.query._page);
      const range = 5;
      const offset = Math.ceil(range / 2);
      const total = this.totalPages;
      const pagesArray = [];

      for (let i = 1; i <= total; i++) {
        pagesArray.push(i);
      }

      pagesArray.splice(0, current - offset);
      pagesArray.splice(range, total);

      return {
        pagesArray,
        current
      };
    },
    totalPages() {
      const t = this.totalOfEntries / this.entriesPerPage;
      return t !== Infinity ? Math.ceil(t) : 0;
    }
  }
};
</script>

<style scoped>
.pagination-container {
  padding: 25px 5px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

li {
  display: inline-block;
}

li button {
  padding: 6px 10px;
  border-radius: 4px;
  margin: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  font-family: "Poppins", Tahoma, Geneva, Verdana, sans-serif;
}
li button:hover,
li button.router-link-exact-active {
  background: #9e1b32;
  color: #fff;
}
</style>
